export default "__VITE_ASSET__Cg2XghZW__"